"use client";

import { Dislike, Like1 } from "iconsax-reactjs";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

const FA = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
const faNum = (n: number) => String(n).replace(/[0-9]/g, (d) => FA[Number(d)]);

interface VoteButtonsProps {
  likeCount: number;
  dislikeCount: number;
  myVote: "like" | "dislike" | null;
  onVote: (value: "like" | "dislike") => void;
  disabled?: boolean;
}

export const VoteButtons: React.FC<VoteButtonsProps> = ({
  likeCount,
  dislikeCount,
  myVote,
  onVote,
  disabled,
}) => {
  const t = useTranslations("blog");
  return (
    <div className="flex items-center gap-4">
      <button
        type="button"
        disabled={disabled}
        onClick={() => onVote("like")}
        aria-label={t("vote.like")}
        aria-pressed={myVote === "like"}
        className={cn(
          "inline-flex items-center gap-1.5 text-sm text-text-secondary transition-colors disabled:opacity-50",
          myVote === "like" && "text-accent",
        )}
      >
        <Like1 size={20} variant={myVote === "like" ? "Bold" : "Linear"} />
        {faNum(likeCount)}
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onVote("dislike")}
        aria-label={t("vote.dislike")}
        aria-pressed={myVote === "dislike"}
        className={cn(
          "inline-flex items-center gap-1.5 text-sm text-text-secondary transition-colors disabled:opacity-50",
          myVote === "dislike" && "text-semantic-error",
        )}
      >
        <Dislike size={20} variant={myVote === "dislike" ? "Bold" : "Linear"} />
        {faNum(dislikeCount)}
      </button>
    </div>
  );
};
